// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'wrench-solid';

export const Component = () => (
  <path d='M18.007.573c.191.432.144.815-.191 1.102l-1.054 1.054-.383 3.831 1.676 1.677 3.784-.335 1.054-.958c.144-.144.383-.24.67-.24.144 0 .24.048.383.097.383.144.575.431.575.91-.048 2.06-.766 3.784-2.203 5.22-1.437 1.485-3.209 2.203-5.364 2.203-1.102 0-2.06-.191-2.97-.575l-9.051 9.052c-.575.623-1.245.91-2.06.91-.766 0-1.436-.287-2.011-.862C.287 23.133 0 22.462 0 21.648c0-.814.287-1.533.862-2.06l9.1-9.051c-.623-1.485-.814-2.921-.48-4.407.288-1.532.959-2.825 2.06-3.927C12.835.814 14.655.096 17.098 0c.479 0 .766.191.91.575l-.001-.002Z' />
);

export const viewBox = '0 0 25 25';
